import { gql } from "graphql-request";

export const GET_USER_PROFILES = gql`
  query GetUserProfiles(
    $where: userprofileFilterInput
    $order: [DynamicSortInput!]
    $pageNo: Int!
    $pageSize: Int!
  ) {
    getuserprofiles(
      where: $where
      order: $order
      paging: { pageNo: $pageNo, pageSize: $pageSize }
    ) {
      totalCount
      totalPages
      hasNextPage
      hasPreviousPage
      items {
        ItemId
        CreatedDate
        CreatedBy
        LastUpdatedDate
        LastUpdatedBy
        IsDeleted
        Language
        OrganizationId
        Tags
        DeletedDate
        gender
        dob
        birthdayMD
        designation
        department
        company
        website
        address
        description
        backgroundImageUrl
        archivedEventIds
        wikiSaved
        newsSaved
        newsDraftIds
        wikiDraftIds
        savedPostIds
        joinedGroupIds
        preferences {
          lightMode
          language
          notificationsEnabled
        }
      }
    }
  }
`;

export const UPDATE_USER_PROFILE = gql`
  mutation UpdateUserProfile(
    $createdBy: String!
    $gender: String
    $dob: String
    $birthdayMD: String
    $designation: String
    $department: String
    $company: String
    $website: String
    $address: String
    $description: String
    $backgroundImageUrl: String
    $archivedEventIds: [String]
    $wikiSaved: [String]
    $newsSaved: [String]
    $newsDraftIds: [String]
    $wikiDraftIds: [String]
    $savedPostIds: [String]
    $joinedGroupIds: [String]
    $preferences: PreferencesInput
  ) {
    updateuserprofile(
      where: { CreatedBy: { eq: $createdBy } }
      input: {
        gender: $gender
        dob: $dob
        birthdayMD: $birthdayMD
        designation: $designation
        department: $department
        company: $company
        website: $website
        address: $address
        description: $description
        backgroundImageUrl: $backgroundImageUrl
        archivedEventIds: $archivedEventIds
        wikiSaved: $wikiSaved
        newsSaved: $newsSaved
        newsDraftIds: $newsDraftIds
        wikiDraftIds: $wikiDraftIds
        savedPostIds: $savedPostIds
        joinedGroupIds: $joinedGroupIds
        preferences: $preferences
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const GET_USER_ARCHIVED_EVENT_IDS = gql`
  query GetUserArchivedEventIds(
    $where: userprofileFilterInput
    $order: [DynamicSortInput!]
    $pageNo: Int!
    $pageSize: Int!
  ) {
    getuserprofiles(
      where: $where
      order: $order
      paging: { pageNo: $pageNo, pageSize: $pageSize }
    ) {
      items {
        CreatedBy
        archivedEventIds
      }
    }
  }
`;

export const UPDATE_USER_ARCHIVED_EVENT_IDS = gql`
  mutation UpdateUserArchivedEventIds(
    $createdBy: String!
    $archivedEventIds: [String]
  ) {
    updateuserprofile(
      where: { CreatedBy: { eq: $createdBy } }
      input: { archivedEventIds: $archivedEventIds }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const GET_ALL_USER_PROFILES = gql`
  query GetAllUserProfiles($month: String, $orgId: String) {
    getuserprofiles(
      where: { dob: { contains: $month }, OrganizationId: { eq: $orgId } }
      order: []
      paging: { pageNo: 1, pageSize: 100 }
    ) {
      items {
        ItemId
        CreatedBy
        dob
        birthdayMD
      }
      totalCount
    }
  }
`;
